import script from "./Tooth28.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooth28.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__